import { Box, xcss } from '@atlaskit/primitives';
import React from 'react';

import { type ADFDocument } from '@canvas/adf';
import { resolveRichTextValue } from '@canvas/adf/resolve-rich-text-value';
import { CommentRenderer } from '@canvas/editor/comment-renderer';

import { type TextLikeFieldType } from '../types.ts';

import { type ViewComponentProps } from './types.ts';

const containerStyles = xcss({
  color: 'color.text',
  minWidth: '0'
});

const disabledContainerStyles = xcss({
  color: 'color.text.disabled',
  minWidth: '0'
});

function RichTextValueView<Type extends TextLikeFieldType>({
  value,
  showDisabledValue
}: ViewComponentProps<Type>) {
  const document: ADFDocument = resolveRichTextValue(value);

  return (
    <Box xcss={showDisabledValue ? disabledContainerStyles : containerStyles} as="div">
      <CommentRenderer document={document} alignment="left" />
    </Box>
  );
}

export default RichTextValueView;
